import styled from 'styled-components'

export const PageWrappper = styled.main`
  padding: 0;
  background: #ffffff;
`

export const ProfilePageTitle = styled.h1`
  margin: 0 0 24px;
  color: #000000;
  font-family: Inter, sans-serif;
  font-size: 24px;
  font-weight: 600;
  line-height: 120%;
`

export const ProfileLayoutGrid = styled.div`
  display: grid;
  grid-template-columns: 270px minmax(0, 1fr);
  gap: 24px;
  align-items: start;

  @media (max-width: 768px) {
    grid-template-columns: minmax(0, 1fr);
  }
`

export const ProfileNavigationWrapper = styled.nav`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const ProfileNavigationButton = styled.button`
  width: 270px;
  min-height: 42px;
  padding: 10px 16px;
  border: 1px solid ${props => (props.$active ? '#00B2FF' : '#E2E8F0')};
  border-radius: 8px;
  background: ${props => (props.$active ? '#EFF8FE' : '#FFFFFF')};
  color: ${props => (props.$active ? '#0F172A' : '#475569')};
  cursor: pointer;
  font-size: 14px;
  font-weight: ${props => (props.$active ? 600 : 400)};
  line-height: 20px;
  text-align: left;
  transition: background-color 0.2s ease, border-color 0.2s ease,
    color 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    border-color: #9cd4fc;
    background: #f8fafc;
    color: #0f172a;
  }

  &:focus {
    outline: none;
  }

  &:focus-visible {
    border-color: #9cd4fc;
    box-shadow: 0 0 0 3px rgba(112, 174, 251, 0.18);
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`

export const ProfileContentPanel = styled.section`
  min-width: 0;
  align-self: start;
  padding: 24px;
  border-radius: 16px;
  background: #f6f6f6;
`

export const ProfileSectionTitle = styled.h2`
  margin: 0 0 16px;
  color: #0f172a;
  font-size: 18px;
  font-weight: 600;
  line-height: 26px;
`

export const ProfileInnerCard = styled.div`
  padding: 24px;
  border-radius: 16px;
  background: #ffffff;

  .ant-input,
  .ant-input-password,
  .ant-select-selector,
  .ant-picker {
    min-height: 40px;
    border-color: #e2e8f0;
    border-radius: 8px;
  }

  .ant-input:hover,
  .ant-input-password:hover,
  .ant-select:not(.ant-select-disabled):hover .ant-select-selector,
  .ant-picker:hover {
    border-color: #bae6fd;
  }

  .ant-input:focus,
  .ant-input-focused,
  .ant-input-password-focused,
  .ant-select-focused:not(.ant-select-disabled).ant-select:not(.ant-select-customize-input)
    .ant-select-selector,
  .ant-picker-focused {
    border-color: #9cd4fc;
    box-shadow: 0 0 0 3px rgba(112, 174, 251, 0.18);
  }

  .ant-input::placeholder {
    color: #94a3b8;
  }
`

export const ProfileFormFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 24px;
`

export const OverviewEditButton = styled.button`
  position: absolute;
  top: -48px;
  right: 0;
  padding: 0;
  border: none;
  background: transparent;
  color: #0077c8;
  cursor: pointer;

  &:hover {
    color: #005a9e;
  }
`

export const OverviewAvatarColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
`

export const OverviewUploadTextButton = styled.span`
  color: #0077c8;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 14px;

  &:hover {
    color: #005a9e;
  }
`

export const OverviewAvatarActionRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
`

export const OverviewAvatarName = styled.div`
  max-width: 100%;
  color: #262626;
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
  text-align: center;
  word-break: break-word;
`

export const ProfileGroupWrapper = styled.div`
  margin-bottom: 0;

  .ant-col.ant-form-item-label {
  }
`

export const ViewFieldCardWrapper = styled.div`
  height: 100%;
  padding: 16px 20px;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);

  .profile-field-title {
    margin-bottom: 6px;
    color: #475569;
    font-size: 13px;
  }

  .profile-field-value {
    color: #0f172a;
    font-size: 14px;
    font-weight: 500;
  }

  .profile-field-value-empty {
    color: #94a3b8;
    font-size: 14px;
    font-weight: 400;
  }
`
